module.exports = __webpack_public_path__ + "img/power1.863303e4.png";